const uniqKeyGenerator = (array) => {
  if (array) {
    array.forEach((item) => {
      // oxlint-disable-next-line no-param-reassign
      item.id = Math.random().toString(36).substr(2, 9);
    });
  }
};

export default uniqKeyGenerator;
